// Import and use some of the 'solid', 'regular', 'light' and 'brand' themes of FontAwesome 5 Free/PRO (.npmrc is required)
// We only add icons to the library that we actually use in frontend to keep the bundle size as small as possible
import { library, dom } from '@fortawesome/fontawesome-svg-core'

// Regular icons
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch'
import { faBars } from '@fortawesome/pro-regular-svg-icons/faBars'
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'

// Solid icons
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle'
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle'
import { faQuoteLeft } from '@fortawesome/pro-solid-svg-icons/faQuoteLeft'

// Light icons
import { faAngleLeft } from '@fortawesome/pro-light-svg-icons/faAngleLeft'
import { faAngleRight } from '@fortawesome/pro-light-svg-icons/faAngleRight'
import { faAngleUp } from '@fortawesome/pro-light-svg-icons/faAngleUp'
import { faAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown'
import { faGlobe } from '@fortawesome/pro-light-svg-icons/faGlobe'
import { faDownload } from '@fortawesome/pro-light-svg-icons/faDownload'
import { faPhone } from '@fortawesome/pro-light-svg-icons/faPhone'
import { faEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope'
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight'
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft'
import { faTh } from '@fortawesome/pro-light-svg-icons/faTh'
import { faList } from '@fortawesome/pro-light-svg-icons/faList'
import { faChartLine } from '@fortawesome/pro-light-svg-icons/faChartLine'
import { faCode } from '@fortawesome/pro-light-svg-icons/faCode'
import { faTag } from '@fortawesome/pro-light-svg-icons/faTag'
import { faFile } from '@fortawesome/pro-light-svg-icons/faFile'
import { faFilePdf } from '@fortawesome/pro-light-svg-icons/faFilePdf'
import { faFileImage } from '@fortawesome/pro-light-svg-icons/faFileImage'
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck'
import { faSitemap } from '@fortawesome/pro-light-svg-icons/faSitemap'
import { faEye } from '@fortawesome/pro-light-svg-icons/faEye'
import { faCalculator } from '@fortawesome/pro-light-svg-icons/faCalculator'
import { faDesktop } from '@fortawesome/pro-light-svg-icons/faDesktop'
import { faGraduationCap } from '@fortawesome/pro-light-svg-icons/faGraduationCap'
import { faExternalLink } from '@fortawesome/pro-light-svg-icons/faExternalLink'
import { faBullseye } from '@fortawesome/pro-light-svg-icons/faBullseye'
import { faPaperPlane } from '@fortawesome/pro-light-svg-icons/faPaperPlane'
import { faChalkboardTeacher } from '@fortawesome/pro-light-svg-icons/faChalkboardTeacher'
import { faRocket } from '@fortawesome/pro-light-svg-icons/faRocket'
import { faMapMarker } from '@fortawesome/pro-light-svg-icons/faMapMarker'
import { faBuilding } from '@fortawesome/pro-light-svg-icons/faBuilding'
import { faHandPointRight } from '@fortawesome/pro-light-svg-icons/faHandPointRight'
import { faCircleNotch } from '@fortawesome/pro-light-svg-icons/faCircleNotch'

// USPs
import { faSmile } from '@fortawesome/pro-light-svg-icons/faSmile'
import { faComments } from '@fortawesome/pro-light-svg-icons/faComments'
import { faComment } from '@fortawesome/pro-light-svg-icons/faComment'
import { faChartBar } from '@fortawesome/pro-light-svg-icons/faChartBar'
import { faGlasses } from '@fortawesome/pro-light-svg-icons/faGlasses'
import { faCar } from '@fortawesome/pro-light-svg-icons/faCar'
import { faBalanceScaleRight } from '@fortawesome/pro-light-svg-icons/faBalanceScaleRight'
import { faGift } from '@fortawesome/pro-light-svg-icons/faGift'
import { faLightbulb } from '@fortawesome/pro-light-svg-icons/faLightbulb'
import { faStopCircle } from '@fortawesome/pro-light-svg-icons/faStopCircle'
import { faSync } from '@fortawesome/pro-light-svg-icons/faSync'
import { faHandsHelping } from '@fortawesome/pro-light-svg-icons/faHandsHelping'
import { faUsers } from '@fortawesome/pro-light-svg-icons/faUsers'
import { faStar } from '@fortawesome/pro-light-svg-icons/faStar'
import { faThumbsUp } from '@fortawesome/pro-light-svg-icons/faThumbsUp'
import { faStreetView } from '@fortawesome/pro-light-svg-icons/faStreetView'

// Add imported icons to the library
library.add(
    faSearch, faBars, faTimes,
    faExclamationTriangle, faCircle, faQuoteLeft,
    faAngleLeft, faAngleRight, faAngleUp, faAngleDown, faGlobe, faDownload,
    faPhone, faEnvelope, faChevronRight, faChevronLeft, faTh, faList, faChartLine, faCode, faTag, faFile, faFilePdf, faFileImage,
    faCheck, faSitemap, faEye, faCalculator, faDesktop, faGraduationCap, faExternalLink, faBullseye, faPaperPlane, faChalkboardTeacher, faRocket,
    faSmile, faComments, faComment, faChartBar, faGlasses, faBalanceScaleRight, faCar,
    faGift, faLightbulb, faStopCircle, faSync, faHandsHelping, faUsers,
    faStar, faThumbsUp, faStreetView, faMapMarker, faBuilding, faHandPointRight, faCircleNotch
)

// Kicks off the process of finding <i> tags and replacing with <svg>
dom.watch()
